import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {useTranslation} from 'react-i18next'
import {SetUserLanguage} from '../../../../redux/system/user/userSlice'
import {useAppDispatch} from '../../../../redux/hooks'
import {showMessage} from '_metronic/helpers/swalHelper'

const languages = [
  {
    lang: 'dr',
    nameDr: 'دری',
    nameEn: 'Dari',
    namePa: 'دری',
    flag: toAbsoluteUrl('/media/flags/afghanistan.svg'),
  },
  {
    lang: 'pa',
    nameDr: 'پشتو',
    nameEn: 'Pashto',
    namePa: 'پشتو',
    flag: toAbsoluteUrl('/media/flags/afghanistan.svg'),
  },
  {
    lang: 'en',
    nameDr: 'انگلیسی',
    nameEn: 'English',
    namePa: 'انگلیسی',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  },
]

const Languages: FC = () => {
  const {t, i18n} = useTranslation()
  const dispatch = useAppDispatch()

  const handleChangeLanguage = (lang: string) => {
    dispatch(SetUserLanguage(lang)).then((res: any) => {
      if (res.meta.requestStatus === 'fulfilled') {
        i18n.changeLanguage(lang)
        window.location.reload()
      } else if (res.meta.requestStatus === 'rejected') {
        showMessage(t('MESSAGES.SERVER_ERROR'), 'error')
      }
    })
  }

  const currentLanguage = languages.find((x) => x.lang === i18n.language)

  return (
    <div
      className='menu-item px-5'
      data-kt-menu-trigger='hover'
      data-kt-menu-placement='left-start'
      data-kt-menu-flip='bottom'
    >
      <button type='button' className='menu-link px-5 bg-transparent border-0'>
        <span className='menu-title position-relative'>
          <span className='fa fa-globe px-1'></span>
          {t('GLOBAL.LANGUAGE')}
          <span className='fs-8 rounded bg-default px-3 d-inline-flex align-items-center'>
            {currentLanguage?.lang === 'dr'
              ? currentLanguage.nameDr
              : currentLanguage?.lang === 'pa'
              ? currentLanguage.namePa
              : currentLanguage?.nameEn}
            <img
              className='w-15px h-15px rounded-1 ms-2 mx-1'
              src={currentLanguage?.flag}
              alt='current language'
            />
          </span>
        </span>
      </button>

      <div className='menu-sub menu-sub-dropdown w-175px py-4'>
        {languages.map((l) => (
          <div
            className='menu-item px-3'
            key={l.lang}
            onClick={() => handleChangeLanguage(l.lang)}
            role='button'
            tabIndex={0}
          >
            <span
              className={clsx('menu-link d-flex px-5', {
                active: l.lang === currentLanguage?.lang,
              })}
            >
              <span className='symbol symbol-20px mx-2'>
                <img className='rounded-1 mx-1' src={l.flag} alt={l.nameEn} />
              </span>
              {currentLanguage?.lang === 'dr'
                ? l.nameDr
                : currentLanguage?.lang === 'pa'
                ? l.namePa
                : l.nameEn}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export {Languages}
